import { createIconComponent } from '../../factory/create-icon-component';
export const UndoIcon = createIconComponent(
  'UndoIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 15V7M2 15H9.77778M2 15C2 15 7 7 13 7C21 7 22 15 22 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
